import { FC } from 'react'

import Typography from '@/ui/components/typography'

import { Badge } from './HeaderSeverityBadge.styles'
import { HeaderSeverityBadgeProps } from './HeaderSeverityBadge.types'

const HeaderSeverityBadge: FC<HeaderSeverityBadgeProps> = ({
    severity,
    dataTestId,
}) => {
    return (
        <Badge
            severity={severity}
            data-testid={dataTestId ?? `header-severity-${severity}`}
        >
            <Typography variant="s-regular" color="inherit">
                {severity}
            </Typography>
        </Badge>
    )
}

export default HeaderSeverityBadge
